import { __DEV__ } from '~src/config';

export const appLog: typeof console.log = (...args) => {
  if (__DEV__) {
    console.log(...args);
  }
};

/**
 * Development debug logging - only logs in non-production environments
 * Use this for debug messages that should stay in code for future development
 * but never appear in production
 */
export const devLog: typeof console.log = (...args) => {
  if (process.env.REACT_APP_STAGE !== 'production') {
    console.log('[DEV]', ...args);
  }
};

/**
 * Feature-specific debug logging - can be toggled independently
 * Usage: debugLog('SVF', 'transcribe started', { fileId: 123 })
 */
export const debugLog = (feature: string, ...args: any[]) => {
  if (process.env.REACT_APP_STAGE !== 'production') {
    console.log(`[DEBUG:${feature}]`, ...args);
  }
};
